import { render, staticRenderFns } from "./PrivacyPolicyStatement.vue?vue&type=template&id=59be1b9a&scoped=true&"
import script from "./PrivacyPolicyStatement.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyStatement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyStatement.vue?vue&type=style&index=0&id=59be1b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be1b9a",
  null
  
)

/* custom blocks */
import block0 from "@/locales/actions.locale?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Cpia%5Ccomponents%5CPrivacyPolicyStatement.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/public/locales/modules/pia/components/PrivacyPolicyStatement.json?vue&type=custom&index=1&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cpublic%5Cmodules%5Cpia%5Ccomponents%5CPrivacyPolicyStatement.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports